import { render, staticRenderFns } from "./TemplateDrawer.vue?vue&type=template&id=36ff468e&scoped=true&lang=pug&"
import script from "./TemplateDrawer.vue?vue&type=script&lang=js&"
export * from "./TemplateDrawer.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDrawer.vue?vue&type=style&index=0&id=36ff468e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ff468e",
  null
  
)

/* custom blocks */
import block0 from "./TemplateDrawer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports